import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import Hero from "./components/Hero";
import CategorySection from "./components/CategorySection";
import About from "./components/About";
import Cards from "./components/Cards";
import PillarArticles from "./components/PillarArticles";

const SITE_ORIGIN = (import.meta.env.VITE_SITE_URL || "https://usfanslink.fun").replace(/\/$/, "");
const SITE_LOGO = "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/2277e9ffbdee9fd651886f1aeeba0d56.jpeg";

const websiteSchema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      name: "USFansLink",
      url: `${SITE_ORIGIN}/`,
      logo: {
        "@type": "ImageObject",
        url: SITE_LOGO,
      },
    },
    {
      "@type": "WebSite",
      name: "USFansLink",
      url: `${SITE_ORIGIN}/`,
      inLanguage: ["en", "pl", "es", "fr"],
    },
  ],
};

export default function Home() {
  return (
    <div className="min-h-screen flex flex-col">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <SiteHeader />
      <main className="flex-1">
        <Hero />
        <CategorySection />
        <About />
        <PillarArticles />
        <Cards />
      </main>
      <SiteFooter />
    </div>
  );
}